import React from "react";
import {
    Card,
} from '@aws-amplify/ui-react';
//import PaymentAddressDetails from "./PaymentAddressDetails";
//import PaymentCartDetails from "./PaymentCartDetails";
import '@aws-amplify/ui-react/styles.css';
import Modal from 'react-modal';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// Amplify configured once in index.js (v6).




export default function Help(props) {

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    Modal.setAppElement('#root');

    return (
        <Card>
            <div className="page-process-wrapper border-top">
                <div className="container">
                    <div className="row no-gutters">
                        <div className="col">
                            <div>
                                <h1>Help &amp; FAQ</h1>
                                <p>
                                    Thank you for your interest in enrolling under the Digit Pet Insurance policy.
                                    Digit Pet Insurance is now available on{' '}
                                    <a href='https://www.pawtectindia.com'>www.pawtectindia.com</a>. If you have bought a
                                    policy with us in the past, please note that the current policy has new coverage(s),
                                    so all the details of your pet need to be filled in again.
                                </p>
                                <p>
                                    For any assistance, contact us between 9AM-5PM, Monday to Friday at{' '}
                                    <a href='tel:+917506562266'>+91-7506562266</a> or{' '}
                                    <a href='tel:+912067445858'>+91-20-67445858</a>, or email{' '}
                                    <a href='mailto:customerservice@pawtectindia.com'>customerservice@pawtectindia.com</a>.
                                </p>

                                <h2>Frequently asked questions</h2>

                                <h3>My payment failed — what should I do?</h3>
                                <p>
                                    No policy is created when a payment fails, and if any amount was debited it
                                    auto-reverses to your original payment method within a few working days. Simply
                                    go back to your cart (the bag icon at the top right) and retry — a new order id will
                                    be generated. If the error keeps happening, contact customer service before retrying.
                                </p>

                                <h3>I didn't receive my form / email</h3>
                                <p>
                                    After a successful payment you receive a payment receipt and an application form for
                                    each pet by email. Please first check your spam/junk folder. If you still can't find
                                    it, email{' '}
                                    <a href='mailto:customerservice@pawtectindia.com'>customerservice@pawtectindia.com</a>{' '}
                                    with your order id and we will resend it.
                                </p>

                                <h3>How do I check my refund status?</h3>
                                <p>
                                    If your proposal is rejected during scrutiny, a full refund of the amount paid is
                                    issued to your original mode of payment. To check the status, email{' '}
                                    <a href='mailto:customerservice@pawtectindia.com'>customerservice@pawtectindia.com</a>{' '}
                                    or call us with your order id.
                                </p>

                                <h2>How to buy a policy</h2>
                                <p>
                                    Step 1 - Click the Quote button on www.pawtectindia.com and enter the age and breed of
                                    your pet, then tick the checkbox for "By clicking 'QUOTE', you agree to join the Vetina
                                    family and receive our newsletters, communications &amp; promotional offers".
                                </p>
                                <p>
                                    Step 2 - Select the appropriate plan (i.e. Blue / Red / Yellow) along with the desired
                                    sum insured (₹40000, ₹60000, ₹100000, ₹150000), click the Cart icon on the top right
                                    corner, then click the Checkout &amp; Pay button.
                                </p>
                                <p>
                                    Step 3 - On the left pane fill in all the details, including Consulting Veterinarian,
                                    Your Name, Mobile, Email and Address. You can search for the nearest area / locality in
                                    "Search Address" and select the address, then provide more information like flat /
                                    bungalow number, building name and street name in the respective text boxes.
                                </p>
                                <p>
                                    Step 4 - Tick the Checkbox for "I hereby agree to avail insurance cover under Digit Pet
                                    Insurance Policy – UIN: IRDAN158RP0006V01202223 arranged by Vetina Healthcare LLP from
                                    Go Digit General Insurance Limited. I hereby declare that I have read the policy Terms
                                    and Conditions carefully".
                                </p>
                                <p>
                                    Step 5 - Click the Pay button and you will be redirected to the Payment Gateway page
                                    with various payment options. You can also enter any discount coupons shared by your
                                    Consulting Veterinarian on this page. Complete the premium payment.
                                </p>
                                <p>
                                    Step 6 - After a successful payment, you will be redirected to www.pawtectindia.com and
                                    you will receive the application form by email. Fill in all the details in the
                                    application form, attach the vaccination card and photo(s) of your pet, and send the
                                    application form to{' '}
                                    <a href='mailto:customerservice@pawtectindia.com'>customerservice@pawtectindia.com</a>.
                                </p>
                                <p>
                                    Step 7 - Digit and Vetina will scrutinise your application form and may contact you for
                                    additional details. After scrutiny the policy will be issued or rejected; in case of
                                    rejection, a full refund of the amount paid by you will be issued to the original mode
                                    of payment.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clearfix"></div>
            <Modal
                isOpen={false}
                style={customStyles}
                contentLabel="Pawtect Payment"
                ariaHideApp={false}
            >
            </Modal>
        </Card>
    );
}


